import React from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import AdditionalInformationInfo from './summaryIncludes/AdditionalInformationInfo';
import CurrentCoverageInfo from './summaryIncludes/CurrentCoverageInfo';
import EmployerCoverageInfo from './summaryIncludes/EmployerCoverageInfo';
import HraInfo from './summaryIncludes/HraInfo';
import ReconcileAptcInfo from './summaryIncludes/ReconcileAptcInfo';
import SubHeader from '../../../headers/SubHeader';
import SummaryFilter from '../../../../../components/ssap/pages/pageIncludes/summary/SummaryFilter';

// Utils

import { normalizeNameOfPerson } from '../../../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { PAGES } from '../../../../../constants/ssap/flows/pagesTypes';
import PageHeader from '../../../../../components/ssap/headers/PageHeader';

// Types

import { SsapSummaryType } from '../../../../../components/ssap/SsapTypes';


const AdditionalInformationSummary = props => {

    const {
        adjustedFlow,
        buttonContainer: ButtonContainer,
        householdMembers,
        indexMapper,
        isRenewalFlow,
        isState,
        itfFeatureEnabled,
        previousData,
        serverDate,
        taxHousehold
    } = props;

    const checkHouseholdMember = idx => {
        
        if (adjustedFlow === undefined) {
            return true;
        } else {
            const pagesListToCheck = [
                PAGES.OTHER_HEALTH_COVERAGE_PAGE,
                PAGES.RECONCILIATION_IN_APTC_PAGE,
                PAGES.EMPLOYER_COVERAGE_DETAIL_PAGE,
                PAGES.STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE,
                PAGES.ADDITIONAL_INFORMATION_PAGE
            ];

            return !pagesListToCheck.every(pageName => !(p => p ? p.isActive : false)(adjustedFlow.find(pg => pg.pageName === pageName && pg.hhm === idx)));
        }
    };
    
    const getHouseholdMembersSummaries = () => householdMembers
        .map((member, idx) => {

            const {
                applicantGuid,
                applyingForCoverageIndicator,
                name,
                householdContact: {
                    homeAddress: {
                        state
                    }
                },
                healthCoverage,
                healthCoverage: {
                    offeredIchraIndicator
                },
                healthReimbursementArrangement,
                employerSponsoredCoverage,
                taxHouseholdComposition: {
                    independentTaxFiler
                }
            } = member;

            if(!checkHouseholdMember(idx)) {
                return null;
            }

            return (
                <SummaryFilter
                    key = { applicantGuid }
                    indexMapper = { indexMapper }
                    summaryId = { SsapSummaryType.ADDITIONAL_INFORMATION.processReplacements({ idx }) }
                >
                    <div className = 'summary__block margin-b-20' >
                        <div className = 'summary__header' >
                            <SubHeader
                                text = 'ssap.subheader.non_internationalized_text'
                                textReplacements = { {
                                    text: (
                                        <FormattedMessage
                                            id = 'ssap.subheader.person_name_primary_contact'
                                            values = { {
                                                personName: normalizeNameOfPerson(name),
                                                primaryContact: (
                                                    <FormattedMessage
                                                        id = { idx === 0 ? 'common.primary_contact' : 'common.no_text' }
                                                    />
                                                )
                                            } }
                                        />
                                    )
                                } }
                                headerClassName = 'gi-heading-alt'
                                additionalElement = {
                                    (
                                        <ButtonContainer
                                            args={ [ idx, PAGES.OTHER_HEALTH_COVERAGE_PAGE ] }
                                            type = 'editButton_secondary'
                                        />
                                    )
                                }
                                additionalElementClassName = 'header-btn'
                            />
                        </div>
                        <div className = 'summary__body' >
                            <div className = 'grid-row' >
                                <CurrentCoverageInfo
                                    { ...{
                                        applyingForCoverageIndicator,
                                        healthCoverage,
                                        idx
                                    } }
                                />
                            </div>

                            <div className = 'grid-row' >
                                <ReconcileAptcInfo
                                    { ...{
                                        independentTaxFiler,
                                        isRenewalFlow,
                                        isState,
                                        itfFeatureEnabled,
                                        member,
                                        name,
                                        serverDate,
                                        taxHousehold
                                    } }
                                />
                            </div>

                            <div className = 'grid-row' >
                                <EmployerCoverageInfo
                                    { ...{
                                        applicantGuid,
                                        applyingForCoverageIndicator,
                                        employerSponsoredCoverage,
                                        healthCoverage,
                                        householdMembers,
                                        idx,
                                        previousData,
                                        state
                                    } }
                                />
                            </div>
                            <div className = 'grid-row' >
                                <HraInfo
                                    { ...{
                                        applicantGuid,
                                        healthReimbursementArrangement,
                                        householdMembers,
                                        idx,
                                        offeredIchraIndicator,
                                        previousData
                                    } }
                                />
                            </div>
                            <div className = 'grid-row' >
                                <AdditionalInformationInfo
                                    { ...{
                                        idx,
                                        healthCoverage,
                                        name
                                    } }
                                />
                            </div>
                        </div>
                    </div>
                </SummaryFilter>
            );
        });

    return (
        <SummaryFilter summaryId = { SsapSummaryType.ADDITIONAL_INFORMATION.processReplacements({ idx: 'ROOT' }) }>
            <div className = 'final-review-heading break_before' >
                <PageHeader
                    text = 'ssap.subheader.additional_info'
                    headerClassName = 'gi-heading-alt'
                />
            </div>
            { getHouseholdMembersSummaries() }
        </SummaryFilter>
    );
};

export default AdditionalInformationSummary;
